// frontend/src/services/whatsapp/portalWhatsAppApi.js
import axios from 'axios';

const API = process.env.REACT_APP_API_URL || 'http://localhost:5000';
const axiosInstance = axios.create({ baseURL: API, withCredentials: true });

export const getSessionStatus = async (schoolId) => {
  // If schoolId is present, append to path; otherwise hit /api/portal/whatsapp/status
  const url = schoolId ? `/api/portal/whatsapp/status/${schoolId}` : '/api/portal/whatsapp/status';
  const response = await axiosInstance.get(url);
  return response.data;
};

export const sendTestMessage = async (recipientPhone, message) => {
  const response = await axiosInstance.post('/api/portal/whatsapp/test-message', {
    recipientPhone,
    message,
  });
  return response.data;
};

export const checkNumber = async (phoneNumber) => {
  const response = await axiosInstance.post('/api/portal/whatsapp/check-number', {
    phoneNumber,
  });
  return response.data;
};